<script lang="ts">
  import { RecaptchaParentId } from './common.ts';
</script>

<div id={RecaptchaParentId} class="invisible relative z-50" />
